import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  // Combine clsx behavior with tailwind-merge to dedupe Tailwind classes
  return twMerge(clsx(inputs));
}

export default cn;
